<template>
  <div v-if="configuraciones && configuraciones.length > 0">
    <template>
      <v-row class="match-height">
        <v-col class="mx-0 px-1">
          <v-hover v-slot="{ hover }">
            <v-card class="error" :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" @click="CerrarSesion()">
              <v-card-text class="text-center py-1 white--text">
                <v-icon color="white">{{ mdiExitToApp }} </v-icon>
                <br />
                <small> <strong>Cerrar sesion</strong> </small>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
        <v-col class="mx-0 px-1">
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" @click="ActualizarForzado()">
              <v-card-text class="text-center py-1">
                <v-icon color="primary">{{ mdiRefresh }} </v-icon>
                <br />
                <small> <strong>Actualizar</strong> </small>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>

        <v-col class="mx-0 px-1" v-if="validarAcciones(acciones.DASHBOARD_COMANDA_ASIGNAR_CAJA)">
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" @click="abrirModalAsignarCaja()">
              <v-card-text class="text-center py-1">
                <v-icon color="primary">{{ mdiAccountLock }} </v-icon>
                <br />
                <small> <strong>Asignar Cajas</strong> </small>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>

        <v-col class="mx-0 px-1" v-if="validarAcciones(acciones.DASHBOARD_COMANDA_FISCALIZAR_COMANDA)">
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" @click="ReporteX()">
              <v-card-text class="text-center py-1">
                <v-icon color="primary">{{ mdiAlphaXCircle }} </v-icon>
                <br />
                <small>
                  <strong>Reporte X</strong> <br />
                  <small>{{ serialFiscal }}</small>
                </small>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
        <v-col class="mx-0 px-1" v-if="validarAcciones(acciones.DASHBOARD_COMANDA_FISCALIZAR_COMANDA)">
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" @click="ReportePreZ()">
              <v-card-text class="text-center py-1">
                <v-icon color="primary">{{ mdiAlphaZCircle }} </v-icon>
                <br />
                <small>
                  <strong>Reporte Z</strong> <br />
                  <small>{{ serialFiscal }}</small>
                </small>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
        <v-col class="mx-0 px-1" v-if="validarAcciones(acciones.DASHBOARD_COMANDA_TRANSFERIR_COMANDA)">
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" @click="abrirModalTransferirMasiva()">
              <v-card-text class="text-center py-1">
                <v-icon color="primary">{{ mdiTransitTransfer }} </v-icon>
                <br />
                <small> <strong>Transferir comanda</strong> </small>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
        <v-col class="mx-0 px-1" v-if="validarAcciones(acciones.DASHBOARD_COMANDA_UNIR_COMANDA)">
          <modal-unir-comanda-vue :comandas="comandas.filter(item => item.estado_pago == 7)"> </modal-unir-comanda-vue>
        </v-col>

        <v-col class="mx-0 px-1" v-if="validarAcciones(acciones.DASHBOARD_PUESTOS_COMANDA_VER)">
          <v-hover v-slot="{ hover }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" v-bind="attrs" v-on="on">
                  <v-card-text class="text-center py-1">
                    <v-icon color="primary">{{ mdiFilterVariant }} </v-icon>
                    <br />
                    <small>
                      <strong>{{
                        filtroEstadoPuesto == 1 ? 'PENDIENTES' : filtroEstadoPuesto == 2 ? 'PROCESADOS' : 'ANULADOS'
                      }}</strong>
                    </small>
                  </v-card-text>
                </v-card>
              </template>
              <v-list>
                <v-list-item link @click="filtroEstadoPuesto = 1">
                  <v-list-item-title>PENDIENTES</v-list-item-title>
                </v-list-item>

                <v-list-item link @click="filtroEstadoPuesto = 2">
                  <v-list-item-title>PROCESADOS</v-list-item-title>
                </v-list-item>

                <v-list-item link @click="filtroEstadoPuesto = 3">
                  <v-list-item-title>ANULADOS</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-hover>
        </v-col>
        <v-col class="mx-0 px-1" v-if="validarAcciones(acciones.DASHBOARD_COMANDA_CREAR_COMANDA)">
          <modal-comanda
            :mesas="mesas"
            :formasPagos="formasPagos"
            :mesoneros="mesoneros"
            :monedas="monedas"
            :configuraciones="configuraciones"
            :estadoFormaPago="estadoFormaPago"
            :serialFiscal="serialFiscal"
            @getNumeroComanda="getNumeroComanda"
            @GetisDialogVisible="GetisDialogVisible"

            ref="RefModalComanda"
          ></modal-comanda>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          v-if="validarAcciones(acciones.DASHBOARD_COMANDA_FISCALIZAR_COMANDA) && serialFiscal == ''"
          class="text-center "
        >
          <v-chip @click="obtenerSerialImpresoraFiscal()" link small label class="mx-1" color="error">
            <span v-if="!serialFiscalCargando && serialFiscal == ''">Impresora fiscal sin conexión (Reintentar)</span>
            <v-progress-circular
              v-if="serialFiscalCargando"
              :size="10"
              :width="3"
              color="red"
              indeterminate
            ></v-progress-circular>
          </v-chip>
        </v-col>
        <v-col lg="6" md="12" sm="12" cols="12">
          <v-text-field
            v-model="filtroComandaTemp"
            hide-details
            :prepend-icon="mdiMagnify"
            single-line
            placeholder="Buscar Comanda..."
            append-icon=""
          >
          </v-text-field>
        </v-col>

        <v-col class="text-right" lg="6" md="12" sm="12" cols="12">
          <v-tabs v-model="tabs" right background-color="transparent">
            <v-tab v-if="validarAcciones(acciones.DASHBOARD_COMANDA_VER_COMANDA)">
              <span>
                <v-switch
                  v-model="switch1"
                  v-if="validarAcciones(acciones.DASHBOARD_COMANDA_MOSTRAR_TODAS_COMANDA)"
                ></v-switch
              ></span>
              <v-badge color="primary" :content="no_comanda"> Comandas </v-badge>
            </v-tab>
            <v-tab
              v-if="store.state.user.puestos.length > 0 && validarAcciones(acciones.DASHBOARD_PUESTOS_COMANDA_VER)"
            >
              <v-btn small icon @click="notifySonido()">
                <v-icon color="primary">{{ mdiMusicCircleOutline }}</v-icon>
              </v-btn>
              <v-badge class="ml-2" color="primary" :content="no_comanda_puesto"> Cola Areas </v-badge>
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-tabs-items v-model="tabs" class="transparent" fixed-tabs>
        <v-tab-item class="transparent" v-if="validarAcciones(acciones.DASHBOARD_COMANDA_VER_COMANDA)">
          <v-container>
            <v-row >
              <v-col
                md="6"
                xl="3"
                cols="12"
                sm="6"
                lg="4"
                v-for="item in FiltrarComanda()"
                :key="item.id + 'modal-comanda'"
              >
                <card-comanda
                  :serialFiscal="serialFiscal"
                  :mesas="mesas"
                  :formasPagos="formasPagos"
                  :mesoneros="mesoneros"
                  :monedas="monedas"
                  :configuraciones="configuraciones"
                  @GetVerComanda="GetVerComanda"
                  :comanda="item"
                  :fiscalizando="fiscalizando"
                  @GetFiscalizando="GetFiscalizando"
                  @GetActualizarEstatusComanda="GetActualizarEstatusComanda"
                  :showAll="showAll"
                >
                </card-comanda>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-pagination
                  v-model="page_number"
                  :length="Number(no_of_pages)"
                  circle
                  :total-visible="'7'"
                ></v-pagination>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item
          v-if="store.state.user.puestos.length > 0 && validarAcciones(acciones.DASHBOARD_PUESTOS_COMANDA_VER)"
        >
          <v-container>
            <v-row>
              <v-col
                md="6"
                xl="3"
                cols="12"
                sm="6"
                lg="4"
                v-for="(item, index) in FiltrarComandaPuesto()"
                :key="index + 'modal-comanda'"
              >
                <card-comanda-puesto :comanda="item" :showAll="true"> </card-comanda-puesto>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-pagination
                  v-model="page_number_puesto"
                  :length="Number(no_of_pages_puesto)"
                  circle
                  :total-visible="'7'"
                ></v-pagination>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <modal-transferir-comanda-masiva ref="modalTransferirMasiva"></modal-transferir-comanda-masiva>
    <modal-asignar-caja ref="modalAsignarCaja"></modal-asignar-caja>
    <ModalVerComanda
      :comanda="comandaSelect"
      :soloVer="true"
      :indFiscal="true"
      :openModal="openModalComanda"
      @GetOpenModal="GetOpenModalComanda"
      :serialFiscal="serialFiscal"
      :monedas="monedas"
    />
    <KeyBoardEvents v-on:keydown="keyboardEvent"></KeyBoardEvents>
    <ConfirmacionUsuario @GetConfirmacionUsuario="GetConfirmacionUsuario" ref="ConfirmacionUsuarioRef" />
    <ModalConfirmacion @GetModalConfirmacion="GetModalConfirmacion" ref="ModalConfirmacionRef" />
    <ModalEntraSalidaCaja ref="ModalEntraSalidaCajaRef" />
    <ModalArqueoCaja  ref="ModalArqueoCajaRef" />
    <ModalPuntosVentasActivos ref="ModalPuntosVentasActivosRef" />
  </div>
  <div v-else>
    <v-dialog :value="(!configuraciones || configuraciones.length == 0 || store.state.configuracionGeneral.configuraciones || store.state.configuracionGeneral.configuraciones.length == 0)"  persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Cargando Datos...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiMagnify,
  mdiChevronDown,
  mdiCallMerge,
  mdiCallSplit,
  mdiSwapHorizontal,
  mdiAlphaZCircle,
  mdiAlphaXCircle,
  mdiInformation,
  mdiCashRegister,
  mdiChevronUp,
  mdiTransitTransfer,
  mdiAccountLock,
  mdiRefresh,
  mdiExitToApp,
  mdiMusicCircleOutline,
  mdiFilterVariant,
} from '@mdi/js'
import StatisticsCardVertical from '@/components/statistics-card/StatisticsCardVertical.vue'
import ModalComanda from './componentes/ModalComanda.vue'
import CardComanda from './componentes/CardComanda.vue'
import ComandaService from '@/api/servicios/ComandaService'
import { onBeforeMount, ref, watch } from '@vue/composition-api'
import { tr } from 'vuetify/lib/locale'
import store from '@/store'
import router from '@/router'
import { acciones } from '@/modulos'
import Vue from 'vue'
import SeguridadService from '@/api/servicios/SeguridadService'
import ImpresoraService from '@/api/servicios/ImpresoraService'
import MaestroService from '@/api/servicios/MaestroService'
import ModalUnirComandaVue from './componentes/ModalUnirComanda.vue'
import KeyBoardEvents from '@/components/KeyBoardEvents.vue'
 
// demos
import CambioClave from '../../administracion/archivo/empleado/CambioClave.vue'
import ModalTransferirComandaMasiva from './componentes/ModalTransferirComandaMasiva.vue'
import ModalAsignarCaja from './componentes/ModalAsignarCaja.vue'
import Ping from 'ping.js'
import ModalVerComanda from '../../administracion/dashboard/componentes/ModalVerComanda.vue'
import CardComandaPuesto from './componentes/CardComandaPuesto.vue'

import ConfirmacionUsuario from '@/components/ConfirmacionUsuario.vue'
import ModalConfirmacion from '@/components/ModalConfirmacion.vue'
import { socket, state as stateSocket } from '@/plugins/sockets'
import ModalEntraSalidaCaja from './componentes/ModalEntraSalidaCaja.vue'
import ModalArqueoCaja from './componentes/ModalArqueoCaja.vue'
import ModalPuntosVentasActivos from './componentes/ModalPuntosVentasActivos.vue'
export default {
  components: {
    StatisticsCardVertical,
    ModalComanda,
    CardComanda,
    ModalUnirComandaVue,
    CambioClave,
    ModalTransferirComandaMasiva,
    ModalAsignarCaja,
    ModalVerComanda,
    CardComandaPuesto,
    KeyBoardEvents,
    ConfirmacionUsuario,
    ModalConfirmacion,
    ModalEntraSalidaCaja,
    ModalArqueoCaja,
    ModalPuntosVentasActivos
  },
  watch: {
    'stateSocket.connected': function (news, olds) {
      if (news) {
        this.suscribirSockets()
        this.ListarComanda()
        this.CargarDatosGenerales()
      }
    },
    'stateSocket.modificarComandaAll': function (news, olds) {
      if (olds < news) {
        setTimeout(() => {
          //alert("modificarComandaAll")
          this.ListarComandaCola()
        }, this.random(1, 5) * 1000)
      }
    },
    'stateSocket.modificarComanda': function (news, olds) {
      if (olds < news) {
        setTimeout(() => {
          //alert("modificarComandaAll")
          this.ListarComanda()
        }, this.random(1, 5) * 1000)
      }
    },
  },
  setup() {
    const comandaSelect = ref(null)
    const openModalComanda = ref(false)
    const modalTransferirMasiva = ref(null)
    const ModalArqueoCajaRef = ref(null)
    const tabs = ref(0)
    const mesas = ref([])
    const showAll = ref(true)
    const formasPagos = ref([])
    const mesoneros = ref([])
    const monedas = ref([])
    const configuraciones = ref([])
    const fiscalizando = ref(false)
    const filtroEstadoPuesto = ref(1)
    const validarAcciones = accion => {
      const valor = store.state.user.accion_modulo.includes(accion)

      return valor
    }
    const ModalEntraSalidaCajaRef = ref(null)
    const isDialogVisible = ref(false)

    const GetisDialogVisible = dato => {
      isDialogVisible.value = dato
    }

    onBeforeMount(() => {
      /* socket.on('modificar-comanda', (...args) => {
        ListarComanda()
      })*/
      suscribirSockets()
      /*
      socket.on('modificar-comanda-all', (...args) => {
        setTimeout(() => {
          ListarComandaCola()
        }, random(1, 10))
      })*/
    })
    function random(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min)
    }
    const ModalConfirmacionRef = ref(null)

    const GetModalConfirmacion = (_funcion, _datos) => {
      _funcion(_datos)
    }

    const GetConfirmacionUsuario = (_funcion, _datos, _funcionCancel, _cancel) => {
      if (_cancel) {
        _funcionCancel()
      } else {
        _funcion(_datos)
      }
    }

    const filtroComandaTemp = ref('')
    let myTimeout = null

    const filtroComandaTriger = () => {
      clearTimeout(myTimeout)
      myTimeout = setTimeout(() => {
        filtoComanda.value = filtroComandaTemp.value
        filtroComandaCargando.value = false
      }, 800)
    }
    const filtroComandaCargando = ref(false)

    watch(filtroComandaTemp, () => {
      if (filtroComandaTemp.value.length >= 1) {
        filtroComandaCargando.value = true
        filtroComandaTriger()
      } else {
        filtroComandaCargando.value = false
        filtoComanda.value = ''
        clearTimeout(myTimeout)
      }

      console.log('filtoComanda', filtroComandaTemp.value)
    })

    const ConfirmacionUsuarioRef = ref(null)
    const suscribirSockets = () => {
      socket.emit('suscribe-comanda-mesonero', {
        suscripcion: 'comanda-mesonero',
        criterio: '',
        valor: validarAcciones(acciones.DASHBOARD_COMANDA_MOSTRAR_TODAS_COMANDA) ? '-1' : store.state.user.id_empleado,
        identificador: store.state.user.usuario,
      })
    }

    const GetOpenModalComanda = datos => {
      openModalComanda.value = false
    }
    const CerrarSesion = () => {
      store.commit('setUserData', {
        userName: '',

        IsAutenticated: false,
        accion_modulo: '[ ]',
        age: 25,
        apellido: '',
        arbol: [],
        autenticate: true,
        caja: {},
        foto: '',
        id: 0,
        id_empleado: 0,
        modulo: '[]',
        nombre: '',
        puestos: [],
        token: '',
        usuario: '',
      })
      router.push({ path: '/pages/login' }).catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      })
    }
    onBeforeMount(() => {
      if (validarAcciones(acciones.DASHBOARD_COMANDA_MOSTRAR_TODAS_COMANDA)) {
        showAll.value = false
      }
      if (validarAcciones(acciones.DASHBOARD_COMANDA_FISCALIZAR_COMANDA)) {
        obtenerSerialImpresoraFiscal()
      }
    })
    const abrirModalTransferirMasiva = () => {
      modalTransferirMasiva.value.abrir()
    }

    const modalAsignarCaja = ref()

    const abrirModalAsignarCaja = () => {
      modalAsignarCaja.value.abrir()
    }

    const switch1 = ref(false)

    const totalesGeneral = ref({
      subTotal: 0,
      servicio: 0,
      iva: 0,
      total: 0,
      cant_total: 0,
      cant_pagados: 0,
      cant_pendiente: 0,
      cant_anulados: 0,
    })
    const sumTotales = () => {
      let totales = {
        subTotal: 0,
        servicio: 0,
        iva: 0,
        total: 0,
        cant_total: 0,
        cant_pagados: 0,
        cant_pendiente: 0,
        cant_anulados: 0,
      }

      comandas.value.forEach(element => {
        totales.cant_total += 1
        if (element.estado_pago != 14 && element.estado_pago != 8) {
          totales.subTotal += element.subtotal
          totales.servicio += element.comision
          totales.iva += element.iva
          totales.total += element.total

          if (element.estado_pago == 7) {
            totales.cant_pendiente += 1
          }
          if (element.estado_pago == 9) {
            totales.cant_pagados += 1
          }
        } else {
          totales.cant_anulados += 1
        }
      })

      totalesGeneral.value = totales
    }

    let ultimaActualizacion = '20000101'
    const comandas = ref([])
    const filtoComanda = ref('')
    const RefModalComanda = ref(null)
    const filtoComandaEstadoPago = ref({ id: 7, descripcion: 'POR COBRAR' })

    const EstadosPago = [
      {
        id: 7,
        descripcion: 'POR COBRAR',
        accion: acciones.DASHBOARD_COMANDA_FILTRAR_COMANDA,
      },
      {
        id: 9,
        descripcion: 'PAGADAS',
        accion: acciones.DASHBOARD_COMANDA_FILTRAR_COMANDA,
      },
      {
        id: 39,
        descripcion: 'POR FISCALIZAR',
        accion: acciones.DASHBOARD_COMANDA_FISCALIZAR_COMANDA,
      },
      {
        id: 40,
        descripcion: 'FISCALIZADA',
        accion: acciones.DASHBOARD_COMANDA_FISCALIZAR_COMANDA,
      },
      {
        id: 14,
        descripcion: 'ANULADAS',
        accion: acciones.DASHBOARD_COMANDA_FILTRAR_COMANDA,
      },
    ]

    const EstadosPagoFiltro = () => {
      return EstadosPago.filter(item => validarAcciones(item.accion))
    }

    let IntervalListarComanda = null
    let counterConsultas = ref(0)
    let counterConsultasCola = ref(0)
    /*watch(counterConsultasCola, () => {
      setTimeout(() => {
        ListarComandaCola()
      }, 5000)
    })*/

    onBeforeMount(() => {
      setTimeout(() => {
        CargarDatosGenerales()
        ListarComanda()
        ListarComandaCola()
      }, 1000)
    })
    const actualizandoForzado = ref(false)
    const ActualizarForzado = () => {
      actualizandoForzado.value = true
      ultimaActualizacion = '20000101'
      comandas.value = []
      ListarComanda(false)
      setTimeout(() => {
        actualizandoForzado.value = false
      }, 5000)
    }
    const estadoFormaPago = ref([])
    const CargarDatosGenerales = () => {
      ComandaService.obtenerDatosGeneralesComanda()
        .then(response => {
          console.log(response)
          mesas.value = response.data.datos.mesas
          formasPagos.value = response.data.datos.forma_pago
          mesoneros.value = response.data.datos.mesoneros
          monedas.value = response.data.datos.monedas
          configuraciones.value = response.data.datos.configuraciones
          estadoFormaPago.value = response.data.datos.estado_forma_pago
          //MonedaPais.value = monedas.value.filter(item => item.meneda_pais == true)[0]
        })
        .catch(error => {
          console.log(error)
        })
    }
    const GetActualizarEstatusComanda = datos => {
      store.commit('setAlert', {
        message: 'Factura fiscalizada con exito',
        type: 'success',
      })

      comandas.value.forEach(element => {
        if (datos.nFactura == element.id) {
          element.factura = { numero_control: datos.numero_control }
          element.estado_fiscalizado = 40
        }
      })
    }
    const GetFiscalizando = datos => {
      fiscalizando.value = datos
    }

    const GetVerComanda = datos => {
      console.log(datos)
      ComandaService.listarComanda({ id: datos.id })
        .then(response => {
          console.log(response)
          if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
            RefModalComanda.value.CargaInicial(response.data.datos)
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
    const page_number = ref(1)
    const no_of_pages = ref(0)
    const no_comanda = ref(0)

    const page_number_puesto = ref(1)
    const no_of_pages_puesto = ref(0)
    const no_comanda_puesto = ref(0)
    watch(filtoComanda, () => {
      page_number.value = 1
    })
    const FiltrarComanda = () => {
      const valor = comandas.value?.filter(
        item =>
          (filtoComanda.value == '' &&
            item.estado_pago == 7 &&
            ((switch1.value == true && item.id_empleado_mesonero == store.state.user.id_empleado) ||
              switch1.value == false)) ||
          (filtoComanda.value != '' &&
            (item.id.toString().includes(filtoComanda.value) ||
              item.cliente.toUpperCase().includes(filtoComanda.value.toUpperCase()) ||
              item.mesonero_nombre.toUpperCase().includes(filtoComanda.value.toUpperCase()) ||
              item.mesa_nombre.toUpperCase().includes(filtoComanda.value.toUpperCase()) ||
              item.nombre_cliente?.toUpperCase().includes(filtoComanda.value.toUpperCase()) ||
              item.apellido_cliente?.toUpperCase().includes(filtoComanda.value.toUpperCase()) ||
              (`${item.nombre_cliente} ${item.apellido_cliente}`).toUpperCase().includes(filtoComanda.value.toUpperCase()) ||
              item.comandero_nombre.toUpperCase().includes(filtoComanda.value.toUpperCase()))) /*&&
          (
            item.estado_pago == filtoComandaEstadoPago.value.id ||
            (item.estado_fiscalizado == filtoComandaEstadoPago.value.id && item.estado_pago != 14) ||
            (filtoComandaEstadoPago.value.id == 39 && ((item.estado_fiscalizado == 39 && item.estado_pago != 14) || item.estado_fiscalizado == 43)) ||
            (filtoComandaEstadoPago.value.id == 40 && ((item.estado_fiscalizado == 40 || item.estado_fiscalizado == 44)))


          )*/,
      )
      if (validarAcciones(acciones.DASHBOARD_COMANDA_MOSTRAR_TODAS_COMANDA)) {
        no_comanda.value = valor.length
        const total_no_of_items = valor.length
        const items_per_page = 8
        no_of_pages.value =
          total_no_of_items / items_per_page > Number((total_no_of_items / items_per_page).toFixed())
            ? Number((total_no_of_items / items_per_page).toFixed()) + 1
            : (total_no_of_items / items_per_page).toFixed()
        const items_to_skip = (page_number.value - 1) * items_per_page
        const items = valor.slice(items_to_skip, items_per_page + items_to_skip)

        return items
      } else {
        no_comanda.value = valor?.filter(item => item.id_empleado_mesonero == store.state.user.id_empleado).length
        const total_no_of_items = valor?.filter(
          item => item.id_empleado_mesonero == store.state.user.id_empleado,
        ).length
        const items_per_page = 8
        no_of_pages.value =
          total_no_of_items / items_per_page > Number((total_no_of_items / items_per_page).toFixed())
            ? Number((total_no_of_items / items_per_page).toFixed()) + 1
            : (total_no_of_items / items_per_page).toFixed()
        const items_to_skip = (page_number.value - 1) * items_per_page
        const items = valor
          ?.filter(item => item.id_empleado_mesonero == store.state.user.id_empleado)
          .slice(items_to_skip, items_per_page + items_to_skip)

        return items
      }
    }

    const FiltrarComandaPuesto = () => {
      let valor = comandasPuesto.value?.filter(
        item =>
          (filtoComanda.value == '' &&
            ((item.estado_despacho < 13 && filtroEstadoPuesto.value == 1) ||
              (item.estado_despacho == 13 && filtroEstadoPuesto.value == 2) ||
              ((item.estado_despacho == 14 || item.detalles.filter(item2 => item2.estado == 14).length > 0) &&
                filtroEstadoPuesto.value == 3))) ||
          (filtoComanda.value != '' &&
            (item.comanda.id.toString().includes(filtoComanda.value) ||
              item.comanda.cliente.toUpperCase().includes(filtoComanda.value.toUpperCase()) ||
              item.comanda.mesonero_nombre.toUpperCase().includes(filtoComanda.value.toUpperCase()) ||
              //item.comanda.nombre_cliente?.toUpperCase().includes(filtoComanda.value.toUpperCase()) ||
              //item.comanda.apellido_cliente.toUpperCase().includes(filtoComanda.value.toUpperCase()) ||
              //(`${item.comanda.nombre_cliente.toUpperCase()} ${item.comanda.apellido_cliente.toUpperCase()}`).includes(filtoComanda.value.toUpperCase()) ||
              item.comanda.mesa_nombre.toUpperCase().includes(filtoComanda.value.toUpperCase()))),
      )
      valor = valor.filter(item => item.items != item.ind_anulado_separa_unido_count)
      no_comanda_puesto.value = valor.length
      const total_no_of_items = valor.length
      const items_per_page = 20
      no_of_pages_puesto.value =
        total_no_of_items / items_per_page > Number((total_no_of_items / items_per_page).toFixed())
          ? Number((total_no_of_items / items_per_page).toFixed()) + 1
          : (total_no_of_items / items_per_page).toFixed()
      const items_to_skip = (page_number_puesto.value - 1) * items_per_page
      const items = valor.slice(items_to_skip, items_per_page + items_to_skip)

      return items
    }

    const ListarComanda = (incrementar = true) => {
      try {
        let comand = []
        let comanda_old = [...comandas.value]
        const id_comandero = validarAcciones(acciones.DASHBOARD_COMANDA_MOSTRAR_TODAS_COMANDA)
          ? -1
          : store.state.user.id_empleado
        ComandaService.listarComandas({ ultima_actualizacion: ultimaActualizacion, id_comandero: id_comandero })
          .then(response => {
            if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
              if (ultimaActualizacion == '20000101') {
                if (response.data?.datos && response.data?.datos?.length > 0) {
                  comandas.value = response.data?.datos
                }
              } else {
                if (response.data.datos.length > 0) {
                  comandas.value = [...comandas.value, response.data.datos]
                  //OPTENER SiN MODICIACION
                  let comandasSinActualizacion = comanda_old.filter(
                    it => !response.data.datos.find(it2 => it.id === it2.id),
                  )
                  /// optener modificaciones
                  let comandasActualizacion = response.data.datos.filter(it =>
                    comanda_old.find(it2 => it.id === it2.id),
                  )
                  //OPTENER NUEVOS
                  let comandasNuevas = response.data.datos.filter(it => !comanda_old.find(it2 => it.id === it2.id))

                  comand = comandasSinActualizacion.concat(comandasActualizacion, comandasNuevas)

                  comand = comand.sort(function (a, b) {
                    if (a.id > b.id) {
                      return 1
                    }
                    if (a.id < b.id) {
                      return -1
                    }
                    return 0
                  })

                  comandas.value = comand
                }
              }
              if (response.data.ultima_actualizacion != null) {
                ultimaActualizacion = response.data.ultima_actualizacion
              }
            }
            if (incrementar == true) {
              counterConsultas.value += 1
            }
          })
          .catch(error => {
            console.error(error)
            if (incrementar == true) {
              counterConsultas.value += 1
            }
          })
          .finally(() => {
            sumTotales()
          })
      } catch (error) {
        console.error(error)
        if (incrementar == true) {
          counterConsultas.value += 1
        }
      }
    }

    var ultimaActualizacionCola = '20000101'
    const comandasPuesto = ref([])
    const ListarComandaCola = (incrementar = true) => {
      try {
        let comand = []
        let comanda_old = [...comandasPuesto.value]

        ComandaService.listarComandasPuesto({ ultima_actualizacion: ultimaActualizacionCola, id_puesto: '53,54' })
          .then(response => {
            if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
              if (ultimaActualizacionCola == '20000101') {
                if (response.data?.datos && response.data?.datos?.length > 0) {
                  comandasPuesto.value = response.data?.datos
                  if (comandasPuesto.value.length > 0) {
                    notifySonido()
                  }
                }
              } else {
                if (response.data.datos.length > 0) {
                  comandasPuesto.value = [...comandasPuesto.value, ...response.data.datos]
                  //OPTENER SiN MODICIACION
                  let comandasSinActualizacion = comanda_old.filter(
                    it => !response.data.datos.find(it2 => it.id === it2.id && it.fecha === it2.fecha),
                  )
                  /// optener modificaciones
                  let comandasActualizacion = response.data.datos.filter(it =>
                    comanda_old.find(it2 => it.id === it2.id && it.fecha === it2.fecha),
                  )
                  //OPTENER NUEVOS
                  let comandasNuevas = response.data.datos.filter(
                    it => !comanda_old.find(it2 => it.id === it2.id && it.fecha === it2.fecha),
                  )

                  if (comandasNuevas.length > 0) {
                    notifySonido()
                  }

                  comand = comandasSinActualizacion.concat(comandasActualizacion, comandasNuevas)

                  comand = comand.sort(function (a, b) {
                    if (a.fecha > b.fecha) {
                      return 1
                    }
                    if (a.fecha < b.fecha) {
                      return -1
                    }
                    return 0
                  })

                  comandasPuesto.value = comand
                }
              }
              if (response.data.ultima_actualizacion != null) {
                ultimaActualizacionCola = response.data.ultima_actualizacion
              }
            }
            if (incrementar == true) {
              counterConsultasCola.value += 1
            }
          })
          .catch(error => {
            console.error(error)
            if (incrementar == true) {
              counterConsultasCola.value += 1
            }
          })
          .finally(() => {})
      } catch (error) {
        console.error(error)
        if (incrementar == true) {
          counterConsultasCola.value += 1
        }
      }
    }
    const impresora = { ...store.state.impresoraFiscal }
    /*const impresora =
 
     {
       modeloImpresora: 1,
       puerto: 99,
       bAudios: 9600,
       paridad: 2,
       datos: 8,
       stopBits: 1,
       handshake: 0,
       maxTiempoEspera: 5000,
       tiempoAntesLectura: 100,
     }*/
    const reporteZLoad = ref(false)

    const ReportePreZ = () => {
      reporteZLoad.value = true

      ComandaService.validarReporteZ()
        .then(response => {
          try {
            if (response.data.estatus == 'true') {
              ConfirmacionUsuarioRef.value.abrir(
                { id_accion_modulo: acciones.DASHBOARD_COMANDA_REPORTE_Z },
                ReporteZ,
                '',
                () => {
                  reporteZLoad.value = false
                },
              )
            } else {
              Vue.swal({
                icon: 'error',
                title: `Disculpa...`,
                text: `${response.data.mensaje}`,
              })
              reporteZLoad.value = false
            }
          } catch (error) {
            Vue.swal({
              icon: 'error',
              title: `Oops...`,
              text: `hubo un error: ${error}`,
            })
            reporteZLoad.value = false
          }
        })
        .catch(error => {
          Vue.swal({
            icon: 'error',
            title: `Oops...`,
            text: `hubo un error: ${error}`,
          })
          reporteZLoad.value = false
        })
    }
    const ReporteZ = () => {
      reporteZLoad.value = true

      if (validarAcciones(acciones.DASHBOARD_COMANDA_REPORTE_Z)) {
        imprimirZ()
      } else {
        let respuesta = {}
        Vue.swal({
          icon: 'info',
          title: 'Credenciales supervisor',
          html:
            '<input type="text" id="swal-input1" class="swal2-input" placeholder="Usuario"> ' +
            '<input type="password" id="swal-input2" class="swal2-input" placeholder="Clave">',
          inputAttributes: {
            autocapitalize: 'off',
          },
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          showLoaderOnConfirm: true,
          cancelButtonText: 'Cancelar',

          preConfirm: login => {
            const usuario = document.getElementById('swal-input1').value
            const clave = document.getElementById('swal-input2').value

            return SeguridadService.validarCredencialesAccionModulo({
              usuario: usuario,
              clave: clave,
              id_accion_modulo: acciones.DASHBOARD_COMANDA_REPORTE_Z,
            })
              .then(response => {
                console.log(response.data)
                respuesta = response.data.datos
                if (response.data.datos == 'ok') {
                  return response.data.datos
                } else {
                  throw new Error('Usuario o clave inavalida, o el usuario no tiene permiso')
                }
              })
              .catch(error => {
                console.error(error)
              })
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then(result => {
          console.log(result)
          if (respuesta == 'ok') {
            if (result.isConfirmed) {
              imprimirZ()
            } else if (result.dismiss === 'cancel') {
              reporteZLoad.value = false
            }
          } else {
            if (result.isConfirmed) {
              Vue.swal({
                icon: 'error',
                title: 'Oops...',
                text: 'Usuario o clave inavalida, o el usuario no tiene permiso',
              })
            } else if (result.dismiss === 'cancel') {
              reporteZLoad.value = false
            } else {
              Vue.swal({
                icon: 'error',
                title: 'Oops...',
                text: 'hubo un error',
              })
            }
            reporteZLoad.value = false
          }
        })
      }
    }

    const imprimirResumenPago = () => {
      ImpresoraService.ImprimirConfiguracion(impresora)
        .then(response => {
          try {
            Vue.swal({
              icon: 'success',
              title: `ok`,
              text: response,
            })
          } catch (error) {
            Vue.swal({
              icon: 'error',
              title: `Oops...`,
              text: `hubo un error: ${error}`,
            })
            reporteZLoad.value = false
          }
        })
        .catch(error => {
          Vue.swal({
            icon: 'error',
            title: `Oops...`,
            text: `hubo un error: ${error}`,
          })
        })
    }
    const imprimirInfoImpresora = () => {
      ImpresoraService.ImprimirConfiguracion(impresora)
        .then(response => {
          try {
            Vue.swal({
              icon: 'success',
              title: `ok`,
              text: response,
            })
          } catch (error) {
            Vue.swal({
              icon: 'error',
              title: `Oops...`,
              text: `hubo un error: ${error}`,
            })
            reporteZLoad.value = false
          }
        })
        .catch(error => {
          Vue.swal({
            icon: 'error',
            title: `Oops...`,
            text: `hubo un error: ${error}`,
          })
        })
    }
    const reverseString = str => {
      // Step 1. Use the split() method to return a new array
      var splitString = str.split('') // var splitString = "hello".split("");
      // ["h", "e", "l", "l", "o"]

      // Step 2. Use the reverse() method to reverse the new created array
      var reverseArray = splitString.reverse() // var reverseArray = ["h", "e", "l", "l", "o"].reverse();
      // ["o", "l", "l", "e", "h"]

      // Step 3. Use the join() method to join all elements of the array into a string
      var joinArray = reverseArray.join('') // var joinArray = ["o", "l", "l", "e", "h"].join("");
      // "olleh"

      //Step 4. Return the reversed string
      return joinArray.toString() // "olleh"
    }
    const stringToNumber = dato => {
      let revers = reverseString(dato.toString())
      let decimal = reverseString(revers.substring(0, 2))
      let entero = revers.substring(2)
      entero = reverseString(entero)

      let valor = parseInt(entero).toString() + '.' + decimal

      return Number(valor).toFixed(2)
    }
    const imprimirZ = () => {
      Vue.swal({
        icon: 'info',
        text: 'Esta seguro que quiere realizar el reporte z',
        showCancelButton: true,
        confirmButtonText: 'Si',
        showLoaderOnConfirm: true,
        cancelButtonText: 'no',
        preConfirm: login => {
          return ImpresoraService.reporteZ(impresora)
            .then(response => {
              console.log('response',response.data)
              try {
                if (response !== '') {
                  /*  const result = `0139
230720
0053
00005202
230720
1646
00000000
00000008
00000301
000000000000014003
000000000000140073
000000000000022412
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000
000000000000000000`*/
                  
                  const resultSplit = response.data.split(/\r\n|\r|\n/)
                  console.log('resultSplit',resultSplit)
                  //const resultSplit = result.split(/\r\n|\r|\n/)

                  let jsonZetas = {
                    numero_reporte_z: Number(resultSplit[0]),
                    fecha_reporte_z: '20' + resultSplit[1],
                    hora_reporte_z: resultSplit[2],
                    numero_ultima_factura_emitida: Number(resultSplit[3]),
                    fecha_ultima_factura: '20' + resultSplit[4],
                    hora_ultima_factura: resultSplit[5],
                    numero_ultima_nota_de_credito: Number(resultSplit[6]),
                    numero_ultima_nota_de_debito: Number(resultSplit[7]),
                    numero_ultimo_documento_no_fiscal: Number(resultSplit[8]),
                    exento_venta: stringToNumber(resultSplit[9]),
                    bi_general_venta: stringToNumber(resultSplit[10]),
                    iva_general_venta: stringToNumber(resultSplit[11]),
                    bi_reducido_venta: stringToNumber(resultSplit[12]),
                    iva_reducido_venta: stringToNumber(resultSplit[13]),
                    bi_adicional_venta: stringToNumber(resultSplit[14]),
                    iva_adicional_venta: stringToNumber(resultSplit[15]),
                    exento_nota_de_debito: stringToNumber(resultSplit[16]),
                    bi_general_nota_de_debito: stringToNumber(resultSplit[17]),
                    iva_general_nota_de_debito: stringToNumber(resultSplit[18]),
                    bi_reducido_nota_de_debito: stringToNumber(resultSplit[19]),
                    iva_reducido_nota_de_debito: stringToNumber(resultSplit[20]),
                    bi_adicional_nota_de_debito: stringToNumber(resultSplit[21]),
                    iva_adicional_nota_de_debito: stringToNumber(resultSplit[22]),
                    exento_nota_de_credito: stringToNumber(resultSplit[23]),
                    bi_general_nota_de_credito: stringToNumber(resultSplit[24]),
                    iva_general_nota_de_credito: stringToNumber(resultSplit[25]),
                    bi_reducido_nota_de_credito: stringToNumber(resultSplit[26]),
                    iva_reducido_nota_de_credito: stringToNumber(resultSplit[27]),
                    bi_adicional_nota_de_credito: stringToNumber(resultSplit[28]),
                    iva_adicional_nota_de_credito: stringToNumber(resultSplit[29]),     
                    bi_igtf: stringToNumber(0),
                    impuesto_percibido_ventas: stringToNumber(0),
                    impuesto_percibido_debito: stringToNumber(0),
                    impuesto_percibido_credito: stringToNumber(0),
                    valor_igtf: stringToNumber(0),
                    bi_igtf_nota_de_credito: stringToNumber(0),
                    valor_igtf_nota_de_credito: stringToNumber(0),
                    bi_igtf_nota_de_debito: stringToNumber(0),
                    valor_igtf_nota_de_debito: stringToNumber(0),             
                    serial_impresora: 'Z7C7022063',
                    datos_impresora: response.data,
                    id_caja: store.state.user.caja.id,
                    id_usuario: store.state.user.id,
                    id_usuario_autorizacion: store.state.user.id,
                  }
                  if (resultSplit.length > 31) {
                    alert('entro')
                    jsonZetas = {
                      ...jsonZetas,
                      bi_igtf: stringToNumber(resultSplit[30]),
                    impuesto_percibido_ventas: stringToNumber(resultSplit[31]),
                    impuesto_percibido_debito: stringToNumber(resultSplit[32]),
                    impuesto_percibido_credito: stringToNumber(resultSplit[33]),
                    valor_igtf: stringToNumber(resultSplit[34]),
                    bi_igtf_nota_de_credito: stringToNumber(resultSplit[35]),
                    valor_igtf_nota_de_credito: stringToNumber(resultSplit[36]),
                    bi_igtf_nota_de_debito: stringToNumber(resultSplit[37]),
                    valor_igtf_nota_de_debito: stringToNumber(resultSplit[38]),
                    }
                  }
                  console.log('jsonZetas', jsonZetas)

                  guardarZ(jsonZetas)
                } else {
                  Vue.swal({
                    icon: 'error',
                    title: `Oops...`,
                    text: `no huvo respuesta de la impresora`,
                  })
                }
              } catch (error) {
                console.log('error zeta',error)
                Vue.swal({
                  icon: 'error',
                  title: `Oops...`,
                  text: `hubo un error: ${error}`,
                })
                reporteZLoad.value = false
              }

              return true
            })
            .catch(error => {
              Vue.swal({
                icon: 'error',
                title: `Oops...`,
                text: `hubo un error: ${error}`,
              })
              reporteZLoad.value = false
              return false
            })
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(result => {
        console.log(result)
        if (result.isConfirmed) {
          reporteZLoad.value = false
        } else if (result.dismiss === 'cancel') {
          reporteZLoad.value = false
        }
      })
    }

    const guardarZ = datos => {
      ComandaService.nuevaZeta({ ...datos, serial_impresora: serialFiscal.value })
        .then(response => {
          try {
            if (response.data.mensaje == 'ZETA GUARDADA CON EXITO') {
              Vue.swal({
                icon: 'success',
                title: `Exito.`,
                text: `${response.data.mensaje}`,
              })
            } else {
              Vue.swal({
                icon: 'error',
                title: `Oops...`,
                text: `hubo un error al guardar en bases de datos, :  ${response.data.mensaje}`,
              })
            }
            reporteZLoad.value = false
          } catch (error) {
            Vue.swal({
              icon: 'error',
              title: `Oops...`,
              text: `hubo un error: ${error}`,
            })
            reporteZLoad.value = false
          }
        })
        .catch(error => {
          Vue.swal({
            icon: 'error',
            title: `Oops...`,
            text: `hubo un error: ${error}`,
          })
          reporteZLoad.value = false
        })
    }

    const reporteXLoad = ref(false)

    const ReporteX = () => {
      reporteXLoad.value = true
      ConfirmacionUsuarioRef.value.abrir(
        { id_accion_modulo: acciones.DASHBOARD_COMANDA_REPORTE_X },
        imprimirX,
        '',
        () => {
          reporteXLoad.value = false
        },
      )
    }
    const serialFiscal = ref('')
    const serialFiscalCargando = ref(false)

    const obtenerSerialImpresoraFiscal = () => {
      serialFiscal.value = ''
      serialFiscalCargando.value = true
      ImpresoraService.obtenerInfo(impresora)
        .then(response => {
          serialFiscal.value = response.data.split('|')[0]
        })
        .catch(error => {
          serialFiscal.value = ''
          store.commit('setAlert', {
            message: 'Error al conectar con la impresora fiscal',
            type: 'error',
          })
        })
        .finally(() => {
          serialFiscalCargando.value = false
        })
    }

    const ArqueoCaja = () => {
      if (validarAcciones(acciones.DASHBOARD_COMANDA_IMPRIMIR_ARQUEO_CAJA)) {
        imprimirArqueoCaja()
      } else {
        let respuesta = {}
        Vue.swal({
          icon: 'info',
          title: 'Credenciales supervisor',
          html:
            '<input type="text" id="swal-input1" class="swal2-input" placeholder="Usuario"> ' +
            '<input type="password" id="swal-input2" class="swal2-input" placeholder="Clave">',
          inputAttributes: {
            autocapitalize: 'off',
          },
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          showLoaderOnConfirm: true,
          cancelButtonText: 'Cancelar',

          preConfirm: login => {
            const usuario = document.getElementById('swal-input1').value
            const clave = document.getElementById('swal-input2').value

            return SeguridadService.validarCredencialesAccionModulo({
              usuario: usuario,
              clave: clave,
              id_accion_modulo: acciones.DASHBOARD_COMANDA_REPORTE_Z,
            })
              .then(response => {
                console.log(response.data)
                respuesta = response.data.datos
                if (response.data.datos == 'ok') {
                  return response.data.datos
                } else {
                  throw new Error('Usuario o clave inavalida, o el usuario no tiene permiso')
                }
              })
              .catch(error => {
                console.error(error)
              })
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then(result => {
          console.log(result)
          if (respuesta == 'ok') {
            if (result.isConfirmed) {
              imprimirArqueoCaja()
            } else if (result.dismiss === 'cancel') {
              reporteXLoad.value = false
            }
          } else {
            if (result.isConfirmed) {
              Vue.swal({
                icon: 'error',
                title: 'Oops...',
                text: 'Usuario o clave inavalida, o el usuario no tiene permiso',
              })
            } else if (result.dismiss === 'cancel') {
              reporteXLoad.value = false
            } else {
              Vue.swal({
                icon: 'error',
                title: 'Oops...',
                text: 'hubo un error',
              })
            }
            reporteXLoad.value = false
          }
        })
      }
    }
    const ArqueoCajaDetallado = () => {
      if (validarAcciones(acciones.DASHBOARD_COMANDA_IMPRIMIR_ARQUEO_CAJA)) {
        imprimirArqueoCajaDetallado()
      } else {
        let respuesta = {}
        Vue.swal({
          icon: 'info',
          title: 'Credenciales supervisor',
          html:
            '<input type="text" id="swal-input1" class="swal2-input" placeholder="Usuario"> ' +
            '<input type="password" id="swal-input2" class="swal2-input" placeholder="Clave">',
          inputAttributes: {
            autocapitalize: 'off',
          },
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          showLoaderOnConfirm: true,
          cancelButtonText: 'Cancelar',

          preConfirm: login => {
            const usuario = document.getElementById('swal-input1').value
            const clave = document.getElementById('swal-input2').value

            return SeguridadService.validarCredencialesAccionModulo({
              usuario: usuario,
              clave: clave,
              id_accion_modulo: acciones.DASHBOARD_COMANDA_REPORTE_Z,
            })
              .then(response => {
                console.log(response.data)
                respuesta = response.data.datos
                if (response.data.datos == 'ok') {
                  return response.data.datos
                } else {
                  throw new Error('Usuario o clave inavalida, o el usuario no tiene permiso')
                }
              })
              .catch(error => {
                console.error(error)
              })
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then(result => {
          console.log(result)
          if (respuesta == 'ok') {
            if (result.isConfirmed) {
              imprimirArqueoCaja()
            } else if (result.dismiss === 'cancel') {
              reporteXLoad.value = false
            }
          } else {
            if (result.isConfirmed) {
              Vue.swal({
                icon: 'error',
                title: 'Oops...',
                text: 'Usuario o clave inavalida, o el usuario no tiene permiso',
              })
            } else if (result.dismiss === 'cancel') {
              reporteXLoad.value = false
            } else {
              Vue.swal({
                icon: 'error',
                title: 'Oops...',
                text: 'hubo un error',
              })
            }
            reporteXLoad.value = false
          }
        })
      }
    }

    const abrirModalComandaAntigua = () => {
      Vue.swal({
        icon: 'warning',
        html:
          '<h3>Ingresa el numero de comanda a buscar  </h3>' +
          ` ` +
          ` <input  id="swal-motivo-anulacion"   class="swal2-input" placeholder="Numero Comanda">  `,
        showCancelButton: true,
        confirmButtonText: 'Si, Seguro',
        showLoaderOnConfirm: true,
        cancelButtonText: 'No',
        preConfirm: async () => {
          const numero = document.getElementById('swal-motivo-anulacion').value

          if (numero != undefined && numero != '' && numero != null && !isNaN(numero)) {
            comandaSelect.value = { id: numero }
            openModalComanda.value = true
            return true
          } else {
            Vue.swal.showValidationMessage(`Debe proporcionar un numero valido`)
          }
        },
        allowOutsideClick: () => {
          !Vue.swal.isLoading()

          GetFiscalizando(false)
        },
      }).then(result => {
        GetFiscalizando(false)
      })
    }

    const AbrirComandaAntigua = () => {
      if (validarAcciones(acciones.DASHBOARD_COMANDA_FISCALIZAR_COMANDA)) {
        abrirModalComandaAntigua()
      } else {
        let respuesta = {}
        Vue.swal({
          icon: 'info',
          title: 'Credenciales supervisor',
          html:
            '<input type="text" id="swal-input1" class="swal2-input" placeholder="Usuario"> ' +
            '<input type="password" id="swal-input2" class="swal2-input" placeholder="Clave">',
          inputAttributes: {
            autocapitalize: 'off',
          },
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          showLoaderOnConfirm: true,
          cancelButtonText: 'Cancelar',

          preConfirm: login => {
            const usuario = document.getElementById('swal-input1').value
            const clave = document.getElementById('swal-input2').value

            return SeguridadService.validarCredencialesAccionModulo({
              usuario: usuario,
              clave: clave,
              id_accion_modulo: acciones.DASHBOARD_COMANDA_REPORTE_Z,
            })
              .then(response => {
                console.log(response.data)
                respuesta = response.data.datos
                if (response.data.datos == 'ok') {
                  return response.data.datos
                } else {
                  throw new Error('Usuario o clave inavalida, o el usuario no tiene permiso')
                }
              })
              .catch(error => {
                console.error(error)
              })
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then(result => {
          console.log(result)
          if (respuesta == 'ok') {
            if (result.isConfirmed) {
              abrirModalComandaAntigua()
            } else if (result.dismiss === 'cancel') {
              reporteXLoad.value = false
            }
          } else {
            if (result.isConfirmed) {
              Vue.swal({
                icon: 'error',
                title: 'Oops...',
                text: 'Usuario o clave inavalida, o el usuario no tiene permiso',
              })
            } else if (result.dismiss === 'cancel') {
              reporteXLoad.value = false
            } else {
              Vue.swal({
                icon: 'error',
                title: 'Oops...',
                text: 'hubo un error',
              })
            }
            reporteXLoad.value = false
          }
        })
      }
    }

    const getNumeroComanda = datos => {
      console.log(datos)
      if (validarAcciones(acciones.DASHBOARD_COMANDA_FISCALIZAR_COMANDA)) {
        filtroComandaTemp.value = datos.id
      }
    }

    const ModalPuntosVentasActivosRef = ref()

    const AbrirArqueoPuntosVentas = (_dato) => {
      console.log(_dato)
      ModalPuntosVentasActivosRef.value.abrir(_dato)
    }

    const imprimirArqueoCaja = (_dato) => {
      ModalArqueoCajaRef.value.abrir(_dato)
      /*
      Vue.swal({
        icon: 'info',
        text: 'Esta seguro que quiere realizar el arqueo de caja',
        showCancelButton: true,
        confirmButtonText: 'Si',
        showLoaderOnConfirm: true,
        cancelButtonText: 'no',

        preConfirm: login => {
          return MaestroService.imprimirArqueoCajaTikera({
            id_grupo_impresora_pc: store.state.tikera.id,
            id_caja: store.state.user.caja.id,
          })
            .then(response => {
              try {
                Vue.swal({
                  icon: 'success',
                  title: `Exito.`,
                  text: `Se envio el aqueo de caja a la impresora.`,
                })
              } catch (error) {
                Vue.swal({
                  icon: 'error',
                  title: `Oops...`,
                  text: `hubo un error: ${error}`,
                })
              }

              return true
            })
            .catch(error => {
              Vue.swal({
                icon: 'error',
                title: `Oops...`,
                text: `hubo un error: ${error}`,
              })

              return false
            })
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(result => {
        console.log(result)

        if (result.isConfirmed) {
          reporteXLoad.value = false
        } else if (result.dismiss === 'cancel') {
          reporteXLoad.value = false
        }
      })*/
    }
    const imprimirArqueoCajaDetallado = () => {
      Vue.swal({
        icon: 'info',
        text: 'Esta seguro que quiere realizar el arqueo de caja',
        showCancelButton: true,
        confirmButtonText: 'Si',
        showLoaderOnConfirm: true,
        cancelButtonText: 'no',

        preConfirm: login => {
          return MaestroService.imprimirArqueoCajaTikeraDetallado({
            id_grupo_impresora_pc: store.state.tikera.id,
            id_caja: store.state.user.caja.id,
          })
            .then(response => {
              try {
                Vue.swal({
                  icon: 'success',
                  title: `Exito.`,
                  text: `Se envio el aqueo de caja a la impresora.`,
                })
              } catch (error) {
                Vue.swal({
                  icon: 'error',
                  title: `Oops...`,
                  text: `hubo un error: ${error}`,
                })
              }

              return true
            })
            .catch(error => {
              Vue.swal({
                icon: 'error',
                title: `Oops...`,
                text: `hubo un error: ${error}`,
              })

              return false
            })
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(result => {
        console.log(result)

        if (result.isConfirmed) {
          reporteXLoad.value = false
        } else if (result.dismiss === 'cancel') {
          reporteXLoad.value = false
        }
      })
    }

    const notifySonido = (title, body) => {
      let url = null
      const _valor = configuraciones.value.find(item => item.id == 6)
      if (_valor?.valor == '1') {
        url = require('@/assets/sonidos/notificacion-1.mp3')
      } else if (_valor?.valor == '2') {
        url = require('@/assets/sonidos/notificacion-2.mp3')
      } else if (_valor?.valor == '3') {
        url = require('@/assets/sonidos/notificacion-karting.mp3')
      } else {
        url = require('@/assets/sonidos/notificacion-1.mp3')
      }

      var audio = new Audio(url)
      audio.play()
    }

    const ModalEntraSalidaCajaAbrir = _dato => {
      ModalEntraSalidaCajaRef.value.abrir(_dato)
    }

    const imprimirX = () => {
      ModalConfirmacionRef.value.abrir({
        subTitulo: 'Esta seguro que quiere realizar el arqueo de caja',
        icon: mdiInformation,

        btnConfirmar: {
          esperarRespuesta: true,
          texto: 'Si',
          color: 'primary',
          funcion: async () => {
            await ImpresoraService.reporteX(impresora)
              .then(response => {
                try {
                  Vue.swal({
                    icon: 'success',
                    title: `Exito.`,
                    text: `Se envio el reporte X a la impresora. ${response.data}`,
                  })
                  reporteXLoad.value = false
                } catch (error) {
                  Vue.swal({
                    icon: 'error',
                    title: `Oops...`,
                    text: `hubo un error: ${error}`,
                  })
                  reporteXLoad.value = false
                }
              })
              .catch(error => {
                Vue.swal({
                  icon: 'error',
                  title: `Oops...`,
                  text: `hubo un error: ${error}`,
                })
                reporteXLoad.value = false
              })
            ModalConfirmacionRef.value.cerrar()
          },
        },
        btnCancelar: {
          texto: 'No',
          color: 'secondary',
          funcion: () => {
            reporteXLoad.value = false
          },
        },
      })

      /*
      Vue.swal({
        icon: 'info',
        text: 'Esta seguro que quiere realizar el reporte x',
        showCancelButton: true,
        confirmButtonText: 'Si',
        showLoaderOnConfirm: true,
        cancelButtonText: 'no',

        preConfirm: login => {
          return ImpresoraService.reporteX(impresora)
            .then(response => {
              try {
                Vue.swal({
                  icon: 'success',
                  title: `Exito.`,
                  text: `Se envio el reporte X a la impresora. ${response.data}`,
                })
                reporteXLoad.value = false
              } catch (error) {
                Vue.swal({
                  icon: 'error',
                  title: `Oops...`,
                  text: `hubo un error: ${error}`,
                })
                reporteXLoad.value = false
              }

              return true
            })
            .catch(error => {
              Vue.swal({
                icon: 'error',
                title: `Oops...`,
                text: `hubo un error: ${error}`,
              })
              reporteXLoad.value = false
              return false
            })
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(result => {
        console.log(result)

        if (result.isConfirmed) {
          reporteXLoad.value = false
        } else if (result.dismiss === 'cancel') {
          reporteXLoad.value = false
        }
      })*/
    }

    const keyboardEvent = e => {
      let tecla = e.which
      if (e.altKey) {
        // Evitar el comportamiento por defecto del nevagador:
        e.preventDefault()
        e.stopPropagation()
        console.log(e.which)
        // Mostrar el resultado de la combinación de las teclas:
        if (tecla === 70) {
          if (validarAcciones(acciones.DASHBOARD_COMANDA_FISCALIZAR_COMANDA) && !isDialogVisible.value) {
            AbrirComandaAntigua()
            return false
          }
        }
        if (tecla === 65) {
          if (validarAcciones(acciones.DASHBOARD_COMANDA_PAGAR_COMANDA) && !isDialogVisible.value) {
            ConfirmacionUsuarioRef.value.abrir(
              { id_accion_modulo: acciones.DASHBOARD_COMANDA_IMPRIMIR_ARQUEO_CAJA },
              imprimirArqueoCaja,
              {},
            )
            return false
          }
        }
        if (tecla === 84) {
          if (!isDialogVisible.value) {
            ConfirmacionUsuarioRef.value.abrir(
              { id_accion_modulo: acciones.DASHBOARD_COMANDA_ENTRADA_SALIDA_CAJA },
              ModalEntraSalidaCajaAbrir,
              {},
            )
            return false
          }
        }
        if (tecla === 73) {
          if (!isDialogVisible.value) {
            ConfirmacionUsuarioRef.value.abrir(
              { id_accion_modulo: acciones.DASHBOARD_COMANDA_FISCALIZAR_COMANDA },
              imprimirInfoImpresora,
              {},
            )
            return false
          }
        }

        if (tecla === 68) {
          if (validarAcciones(acciones.DASHBOARD_COMANDA_PAGAR_COMANDA) && !isDialogVisible.value) {
            // ArqueoCajaDetallado()

            ConfirmacionUsuarioRef.value.abrir(
              { id_accion_modulo: acciones.DASHBOARD_COMANDA_IMPRIMIR_ARQUEO_CAJA },
              imprimirArqueoCajaDetallado,
              '',
            )
            return false
          }
        }

        if (tecla === 80) {
          if (validarAcciones(acciones.DASHBOARD_COMANDA_PAGAR_COMANDA) && !isDialogVisible.value) {
            // ArqueoCajaDetallado()

            ConfirmacionUsuarioRef.value.abrir(
              { id_accion_modulo: acciones.DASHBOARD_COMANDA_IMPRIMIR_ARQUEO_CAJA },
              AbrirArqueoPuntosVentas,
              '',
            )
            return false
          }
        }
      }
    }

    return {
      mdiInformation,
      mdiRefresh,
      mdiMagnify,
      mdiChevronDown,
      mdiCallMerge,
      mdiCallSplit,
      mdiAlphaZCircle,
      mdiSwapHorizontal,
      mdiAlphaXCircle,
      mdiCashRegister,
      mdiTransitTransfer,
      mdiChevronUp,
      mdiExitToApp,
      mdiChevronDown,
      mdiAccountLock,
      mdiMusicCircleOutline,
      mdiFilterVariant,
      ListarComanda,
      comandas,
      FiltrarComanda,
      filtoComanda,
      filtoComandaEstadoPago,
      EstadosPago,
      GetVerComanda,
      RefModalComanda,
      mesas,
      formasPagos,
      mesoneros,
      monedas,
      configuraciones,
      fiscalizando,
      GetFiscalizando,
      GetActualizarEstatusComanda,
      validarAcciones,
      acciones,
      reporteXLoad,
      ReporteX,
      reporteZLoad,
      ReporteZ,
      ReportePreZ,
      imprimirInfoImpresora,
      ArqueoCaja,
      EstadosPagoFiltro,
      showAll,
      tabs,
      store,
      totalesGeneral,
      modalTransferirMasiva,
      abrirModalTransferirMasiva,
      page_number,
      no_of_pages,
      no_comanda,
      abrirModalAsignarCaja,
      modalAsignarCaja,
      ActualizarForzado,
      actualizandoForzado,
      getNumeroComanda,
      switch1,
      serialFiscal,
      serialFiscalCargando,
      obtenerSerialImpresoraFiscal,
      CerrarSesion,
      GetOpenModalComanda,
      openModalComanda,
      comandaSelect,
      stateSocket,
      suscribirSockets,
      CargarDatosGenerales,
      comandasPuesto,
      FiltrarComandaPuesto,
      page_number_puesto,
      no_of_pages_puesto,
      no_comanda_puesto,
      filtroEstadoPuesto,
      AbrirComandaAntigua,
      GetisDialogVisible,
      isDialogVisible,
      ArqueoCajaDetallado,
      GetConfirmacionUsuario,
      ConfirmacionUsuarioRef,
      keyboardEvent,
      filtroComandaTemp,
      filtroComandaCargando,
      ModalConfirmacionRef,
      GetModalConfirmacion,
      notifySonido,
      ModalEntraSalidaCajaRef,
      ModalEntraSalidaCajaAbrir,
      ModalArqueoCajaRef,
      ModalPuntosVentasActivosRef ,
      random,
      ListarComandaCola,
      estadoFormaPago
    }
  },
}
</script>
<style scoped>
  .swal2-html-container {
    z-index: 10000;
  }
</style>